import React, { PureComponent } from 'react'
import { defaultMemoize } from 'reselect'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { truncate, chunk } from 'lodash'
import withStyles from 'material-ui-next/styles/withStyles'
import DistrictFilter from './DistrictFilter'
import AutoCompleteGenere from './AutoCompleteGenere'
import AutoCompleteAttribute from './AutoCompleteAttribute'
import { getTopBarConfig, getCategory } from '../../selectors'
import { uiConfigureTopBar } from '../../actions'
import { getFilterAttributesByCategory } from '../../utils'
import breakpoints from '../../styles/breakpoints'
import { shouldShowGenereFilter, getFiltersChunkedSize } from '../../utils'
import matchMedia from 'matchmedia'

const styles = theme => ({
  filtersMainContainer: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  filtersContainer: {
    display: 'inline-flex',
    paddingTop: 16,
    width: '100%',
  },
  filtersInfoText: {
    color: theme.swapick.colors.lightblack,
    display: 'inline-flex',
    alignItems: 'flex-end',
    paddingLeft: 24,
  },
})

const computeFiltersLines = (category, filterAttributes, chunkedSize) => {
  // Default 1 line of filters
  if (!category || !filterAttributes) {
    return 1
  }
  const showGenereFilter = shouldShowGenereFilter(category)
  const filtersCount = filterAttributes.length + (showGenereFilter ? 1 : 0)
  return Math.ceil(filtersCount / chunkedSize)
}

const getFiltersAttrsChunked = defaultMemoize((showGenere, attrs, size) => {
  if (!attrs) {
    return null
  }
  const allAttrs = (showGenere ? ['_'] : []).concat(attrs)
  return chunk(allAttrs, size)
})

class FiltersToolbar extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      chunkedSize: getFiltersChunkedSize(),
    }
  }

  componentWillMount() {
    this.matchXs = matchMedia(`screen and (max-width: ${breakpoints.xs})`)
    this.matchSm = matchMedia(`screen and (max-width: ${breakpoints.sm})`)
    this.matchMd = matchMedia(`screen and (max-width: ${breakpoints.md})`)

    this.matchSm.addListener(this.updateFiltersChunks)
    this.matchMd.addListener(this.updateFiltersChunks)

    this.updateFiltersChunks()
  }

  componentWillReceiveProps(nextProps) {
    if (
      this.props.category !== nextProps.category ||
      this.props.filterAttributes !== nextProps.filterAttributes
    ) {
      const { category, filterAttributes, filtersLines } = nextProps
      const { chunkedSize } = this.state
      const newLines = computeFiltersLines(
        category,
        filterAttributes,
        chunkedSize
      )
      if (newLines !== filtersLines) {
        this.props.uiConfigureTopBar({
          filtersLines: newLines,
        })
      }
    }
  }

  componentWillUnmount() {
    this.matchSm.removeListener(this.updateFiltersChunks)
    this.matchMd.removeListener(this.updateFiltersChunks)
  }

  updateFiltersChunks = () => {
    const chunkedSize = getFiltersChunkedSize()
    if (chunkedSize !== this.state.chunkedSize) {
      this.setState({ chunkedSize })
    }
    const { category, filterAttributes, filtersLines } = this.props
    const newLines = computeFiltersLines(
      category,
      filterAttributes,
      chunkedSize
    )
    if (newLines !== filtersLines) {
      this.props.uiConfigureTopBar({
        filtersLines: newLines,
      })
    }
  }

  render() {
    const { classes, filterAttributes, category } = this.props
    const { chunkedSize } = this.state
    const showGenereFilter = shouldShowGenereFilter(category)
    const attrsChunked = getFiltersAttrsChunked(
      showGenereFilter,
      filterAttributes,
      chunkedSize
    )

    return (
      <div className={classes.filtersMainContainer}>
        {category && (
          <div>
            {attrsChunked &&
              attrsChunked.map((attrs, j) => (
                <div className={classes.filtersContainer} key={j}>
                  {attrs.map(
                    (attribute, i) =>
                      i === 0 && j === 0 && showGenereFilter ? (
                        <AutoCompleteGenere
                          key={'genere'}
                          placeholder={'Genere'}
                          categoryId={category.id}
                        />
                      ) : (
                        <AutoCompleteAttribute
                          key={attribute.chiave}
                          label={truncate(attribute.descrizione, {
                            length: 23,
                          })}
                          attribute={attribute.chiave}
                          categoryId={category.id}
                        />
                      )
                  )}
                </div>
              ))}
          </div>
        )}
        {!category && (
          <div className={classes.filtersInfoText}>
            Seleziona una categoria per avere più filtri.
          </div>
        )}
        <div>
          <div className={classes.filtersContainer}>
            <DistrictFilter />
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const config = getTopBarConfig(state)
  const category = getCategory(state, config.match.params.category)
  const filterAttributes = category
    ? getFilterAttributesByCategory(category)
    : null

  return {
    filterAttributes,
    category,
    filtersLines: config.filtersLines,
  }
}

export default withRouter(
  withStyles(styles)(
    connect(mapStateToProps, {
      uiConfigureTopBar,
    })(FiltersToolbar)
  )
)



// WEBPACK FOOTER //
// ./src/common/TopBar/FiltersDesktop.js